import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";

/* Blocco 4 — optional Sentry error monitoring (frontend).
   No-op unless REACT_APP_SENTRY_DSN is set in frontend/.env.
   Safe by default: no PII, no session recording, no marketing pixels. */
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_SENTRY_ENV || "preview",
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0"),
    // Never send session replays, cookies or user identity by default.
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.request?.headers) delete event.request.headers.Authorization;
      if (event.request?.cookies) delete event.request.cookies;
      return event;
    },
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

/* Blocco 3 — PWA service worker registration.
   The worker file (`public/service-worker.js`) does cache-first for static
   assets and always fetches fresh for `/api/*`, so it will never serve
   stale API responses. Only registers in production builds to avoid
   caching interference during `yarn start` dev cycles. */
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("[pwa] SW registration failed:", err));
  });
}
